import axios from 'axios';
import { setupInterceptors } from '../core/axiosInterceptor.js';
import { getTenantId } from '../tenant/tenantService.js';

const NOTIFICATIONS_URL = process.env.REACT_APP_NOTIFICATIONS_URL;

const apiInbox = axios.create({
  baseURL: NOTIFICATIONS_URL,
});

setupInterceptors(apiInbox);

const ensureTenantHeader = (config = {}) => {
  const tenantId = getTenantId();
  return tenantId
    ? { ...config, headers: { ...(config.headers || {}), 'X-Tenant-Id': tenantId } }
    : config;
};

export const inboxService = {
  async getUnreadCount() {
    const response = await apiInbox.get('/v1/inbox/unread-count', ensureTenantHeader());
    return response?.data?.count ?? response?.data ?? 0;
  },

  async getNotifications({ page = 1, pageSize = 10, unreadOnly = false } = {}) {
    const params = { page, pageSize, ...(unreadOnly ? { unreadOnly: true } : {}) };
    const response = await apiInbox.get('/v1/inbox', ensureTenantHeader({ params }));
    const data = response?.data;
    return {
      items: data?.items ?? data?.notifications ?? [],
      hasMore: data?.hasMore ?? data?.hasNextPage ?? false,
      total: data?.total ?? data?.totalCount ?? 0,
    };
  },

  async markAsRead(notificationId) {
    const response = await apiInbox.put(
      `/v1/inbox/${notificationId}/read`,
      {},
      ensureTenantHeader()
    );
    return response?.data;
  },

  async markAllAsRead() {
    const response = await apiInbox.put('/v1/inbox/read-all', {}, ensureTenantHeader());
    return response?.data;
  },
};
